import React, { forwardRef } from 'react';

import { cn } from 'common/style/utils';

const HStack = forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ children, className, ...props }, ref) => {
    return (
      <div ref={ref} className={cn('flex flex-row', className)} {...props}>
        {children}
      </div>
    );
  },
);

export default HStack;
